import { globalStore } from '@/assets/js/common/utils'
import {InitThreeJS} from './threejs/initThreeJS'
import {HalloweenSwiper} from './components/halloweenSwiper'
import {Entrance} from './components/entrance'
import {Ring} from './components/ring'
import { Parallax } from './components/parallax'

const indexInit = () => {
  // STORE
  Alpine.store('global', {
    ...globalStore,
  });
  
  // INDEX COMPONENT
  Alpine.data('blindboxComponent', () => ({
    store: globalStore,
		zooming:false,
		zoomed:false,
		faded:false,
    blindboxComponent: {
      ['x-init']() {
        // @ts-ignore
        const _this = this;
        
        // console.log('blindboxComponent: ', 'this.store.breakpoint')
        window.addEventListener('scroll',()=>{
          const ticket = document.querySelector('.halloween-2025-tickets').getBoundingClientRect();
          if(ticket.top<100){
            _this.zooming = true;
            setTimeout(()=>{
              _this.zoomed = true;
            },600)
            setTimeout(()=>{
              _this.faded = true;
            },1000)
          }
        })
      },
    }
  }));
  
  // INDEX COMPONENT
  Alpine.data('indexComponent', () => ({
    store: globalStore,
    indexComponent: {
      ['x-init']() {
        // @ts-ignore
        this.store = (this.$store as HomeStore).global;
        
        console.log('indexComponent: ', this.store.breakpoint)
      },
    }
  }));

	// MAP COMPONENT
  Alpine.data('mapComponent', () => ({
		map3d: false,
		inited: false,
    mapComponent: {
      ['x-init']() {
				//DEV USE
				// this.map3d = true;
				// if(!this.inited){
				// this.inited = true;
				// 	InitThreeJS();
				// }
				// console.log('map');
      },
    },
		toggle(test:any) {
			this.map3d = true;
			if(!this.inited){
				this.inited = true;
				InitThreeJS();
			}
		},
    triggerToggle: {
      ['@click'](e: Event) {
				let cHouse:any = Number(e.currentTarget.dataset.house)-1;
        this.toggle(0);
				setTimeout(()=>{
					let y:any = 0;
					if(window.innerWidth<=767){
						y = window.scrollY
						+ document.querySelector('.halloween-2025-map-inner').getBoundingClientRect().height
						+ document.querySelector('.halloween-2025-map-anchor').getBoundingClientRect().top
						+ (document.querySelector('.halloween-2025-map').getBoundingClientRect().height-window.innerHeight)*cHouse/6;
					}else{
						y = window.scrollY
						+ document.querySelector('.halloween-2025-map-anchor').getBoundingClientRect().top
						+ (document.querySelector('.halloween-2025-map').getBoundingClientRect().height)*cHouse/6;
					}
					window.scrollTo({
						top: y,
						behavior: "smooth",
					});
				},100)
      },
    },
    triggerMap: {
      ['@click'](e: Event) {
				this.map3d = false;
				const y:any = window.scrollY
				+ document.querySelector('.halloween-2025-map-anchor').getBoundingClientRect().top;

				window.scrollTo({
					top: y,
					behavior: "smooth",
				});
      },
    }
  }));
  
  Alpine.data('videoComponent', () => ({
    videoId: '',
    showVideo: false,
    isSc: false,
    playMusic: false,
    store: globalStore,
    videoComponent: {
      ['x-init']() {
        this.isSc = document.querySelector('body')?.classList.contains('i18n-zh-hans');
        // @ts-ignore
        this.store = (this.$store as HomeStore).global;
      },
    },
    videoTrigger: {
      ['@click'](e: Event) {
        // this.playMusic = globalStore.playMusic;
        this.videoId = this.$el.dataset.videoId;
        this.showVideo = true;
        this.$refs.videoPlayer.innerHTML = this.isSc ? 
          // `<iframe src="https://player.youku.com/embed/${this.videoId}" frameborder="0" allowfullscreen></iframe>` : 
          `<iframe src="https://www.youtube.com/embed/${this.videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` :
          `<iframe src="https://www.youtube.com/embed/${this.videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
        
        //Pause background music
        this.store.playMusic = false;
        this.$dispatch('set-play-music', {
          "playMusic": false,
        })
      },
      [":class"]() {
        return { "hide" : this.showVideo };
      },
    },
    videoPlayer: {
      ['x-init'](e: Event) {
      },
      [":class"]() {
        return { "show" : this.showVideo };
      },
    },

  }));

	new HalloweenSwiper();
	new Entrance();
  Ring();
	// new Ring();
	// new Parallax();
}

document.addEventListener('alpine:init', () => {
  indexInit();
})

Alpine.start();